import React, { Component, PureComponent } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"

import PieChart from 'react-minimal-pie-chart';
import Stringify from 'react-stringify'

  import api from "../../services/api"
  import "../../assets/styleadmin.css"


class IndexAdmin extends Component {

    state = {
        matriculas:[],
        search:null,
        faturas:[]
    
      }
    async componentDidMount(){


      
        this.loadmatriculas();
        this.loadfaturas();
    
    
      }



      async loadfaturas(){
       

        const response = await api.post("/admin/relatorio/faturas");
    
        this.setState({
          faturas:response.data
        })

        localStorage.setItem('datarelatfatpaga',this.state.faturas.paga)
        localStorage.setItem('datarelatfatnaopaga',this.state.faturas.naopaga)
        localStorage.setItem('datarelatfatcancelada',this.state.faturas.cancelado)
        localStorage.setItem('datarelatfatreembolsada',this.state.faturas.refund)
        localStorage.setItem('datarelatfattotal',this.state.faturas.total)

        window.reloadfat();
      }



      async loadmatriculas(){
        const response = await api.post("/admin/relatorio/matricula");
    
        this.setState({
          matriculas:response.data
        })

        localStorage.setItem('matpaga',this.state.matriculas.paga)
        localStorage.setItem('matnaopaga',this.state.matriculas.naopaga)
        localStorage.setItem('mattotal',this.state.matriculas.total)
        window.reloadmat();

      }

  render() {
    
  
    
    return (
      <React.Fragment>
          <Header />
          <div class="col-lg-12">
          <center><h4>Relatórios</h4></center>
          <br />
          <center><a class="btn btn-danger" href="/admin/relatorios">Recarregar</a>
          </center>
          <br />
          <div class="row">
              <div class="col d-flex justify-content-center">
                <div id="piechart"></div>
              </div>

              <div class="col d-flex justify-content-center">
                <div id="chart_div"></div>
              </div>
          </div>

          
          


          </div>

      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/relatoriointegral.js